module.exports = __webpack_public_path__ + "static/media/brochure-img-1.4426f096.jpg";